import React, { useEffect, useState } from 'react'; 
import FalconComponentCard from 'components/common/FalconComponentCard'; 
import firebase from './../../../firebase';
import { useParams } from 'react-router-dom';
import { Button,  Col, Form, Row } from 'react-bootstrap'; 
import Select from 'react-select';
import DatePicker , {registerLocale, setDefaultLocale} from 'react-datepicker';
import CustomDateInput from 'components/common/CustomDateInput';
import {   useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'; 
import fr from 'date-fns/locale/fr';
import { useFormatDate  } from 'hooks';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';

import { isEqual, isObject, transform } from 'lodash';
import { API_URL } from 'constants'; 
import Avatar from 'components/common/Avatar';
import { dsv } from 'd3';


const EditEtatdeslieux = () => { 
    const { id } = useParams();
    registerLocale('fr', fr);
    setDefaultLocale('fr');
    const [valueClientId, setValueClientId] = React.useState(null);
    const [valueVilla, setValueVilla] = React.useState(null);
    const [valueVillaPossible, setValueVillaPossible] = React.useState([]);
    const [valueStatut, setValueStatut] = React.useState(null);
     const [validated, setValidated] = React.useState(false);
     const [formd, setFrom] = React.useState({});
    const [mac, setMac] = React.useState({});
    const [l, setL] = React.useState(false);
    const [is_moral, setMoral] = React.useState(false);
    const [is_owner, setIs_Owner] = React.useState(false);
    const [clients, setClients] = React.useState([]);
    const [checkIn, setCheckIn] = React.useState(new Date());
    const [checkOut, setCheckOut] = React.useState(new Date());
     const [booked_date, setBooked_Date] = React.useState(new Date());
    const [emails, setEmails] =  React.useState('');
    const [disabledClientId, setDisableclientId] = React.useState(false);
    const [lsendE, setLsendE] = React.useState(false);
    const [villas, setVilla] =  React.useState([]);

    const [valueInterlocuteur, setValueInterlocuteur] = React.useState(null);
    const [interlocuteurs, setInterlocuteur] =  React.useState([]);
     const [users, setUsers] = React.useState([]);
     const [pieces, setPieces] = React.useState([]);
     

   
    const loadUsers = () => { 
        firebase.firestore().collection('users').get().then((snap)=> {
          let s = [];
          snap.forEach((d) => {
            var l = d.data(); 
            if (l?.delete){
              // supprimer donc ne pas affiché
            }else{ 
                if (l?.type === "admin"){
                    const dr = {value : d.id, label: `${l?.lastName} ${l?.firstName}`, phone :l.phone , email: l.email,   }
                    s.push(dr) 
                } 
            }
            
          })
          setInterlocuteur(s); 
        }).catch((error) => {
          setL(false); 
          var errorMessage = error.message;
          toast.error(errorMessage);
        })
      }
    
 



  const navigate = useNavigate();


  const loadVilla = () => { 
    firebase.firestore().collection('properties').get().then((snap)=> {
      let s = [];
      snap.forEach((d) => {
        var l = d.data(); 
        if (l?.delete){
          // supprimer donc ne pas affiché
        }else{ 
            const dr = {value : d.id, label: `${l?.nameHouse}` , data: l }
            s.push(dr) 
        }
        
      })
      setVilla(s); 
    }).catch((error) => {
      setL(false); 
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }



    const getClients = () => {
        // get list clients and format
        firebase.firestore().collection('crm').get().then((snap)=> {
            let s = [];
            snap.forEach((d) => { 
                let e = '';
                let pre = d.data()?.email?.split(',') || []
                pre.forEach((s) =>{
                    e += `${s}, `;
                })
              const dr = {value : d.id, label: `${d.data()?.lastName} ${d.data()?.firstName}`, email: e }
              if (d.data()?.delete){}
              else{
                s.push(dr)
              }
            })
            setClients(s);
          }).catch((error) => {
            setL(false); 
            var errorMessage = error.message;
            toast.error(errorMessage);
          })

    }

 
const fmi = () => {
    getClients();
        loadVilla();  
        getAllUser();
        loadUsers();
        firebase.firestore().collection('etatsdeslieux').doc(id).get().then(doc => {
          if (doc){ 
            let d = doc.data()
            setMac(doc.data())
            d.id = doc.id;
            // d.email = d.emails.join(', ');
            setFrom(d)  
            setValueClientId(d.client)
            setValueVilla(d.property)
            setValueStatut(d.statut)
            setPieces(d?.pieces || [])
            // setValueOrigin(d.origin)
            // setValueDemande(d.numberDemand);
            setCheckIn(d?.checkin?.toDate())
            // setDemand_Date(d.demand_date?.toDate());
            setCheckOut(d?.checkout?.toDate())
            // setBooked_Date(d?.booked_date?.toDate());
            // setEmails(d.emails.join(', '))
            setDisableclientId(true) ;  
            setValueInterlocuteur(d?.interlocuteur || null)
          }
        })
}
  useEffect(() =>{
    if (id)  {
        fmi()
      }else{
        toast.error('Une erreur s\'est produite.');
      }
  }, []);

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  const characters =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  function generateString(length) {
  let result = '';
  const charactersLength = characters.length;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < length; i++) {
  result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
  } 

  const sendFile = async (file, cb) => {
    const storage = firebase.storage();
    const metadata = {
      contentType: file.type,
    };
    
    const ss = `files/${generateString(10)}.${file?.type?.split("/")[1]}`;
    const reference = storage.ref(ss);

 
        const uploadTask = reference.put(file, metadata);

            uploadTask.on(
              firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
              (snapshot) => {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Upload is ${  progress  }% done`);
                switch (snapshot.state) {
                  case firebase.storage.TaskState.PAUSED: // or 'paused'
                    console.log("Upload is paused");
                    break;
                  case firebase.storage.TaskState.RUNNING: // or 'running'
                    console.log("Upload is running");
                    toast.warning('Fichier en cours d\'envoi, veuillez patientez...')
                    break;
                  default :
                    break;
                }
              },
              (err) => {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (err.code) {
                  case "storage/unauthorized":
                    console.error("err", err)
                    // User doesn't have permission to access the object
                    alert(
                      "Une erreur est survenue lors de l'envoie de votre fichier, vous n'avez pas l'autorisation d'envoyez des documents."
                    );
                    break;
                  case "storage/canceled":
                    // User canceled the upload alert(
                    alert(
                      "Une erreur est survenue lors de l'envoie de votre fichier, vous avez annuler l'envoie."
                    );
                    break;

                  // ...

                  case "storage/unknown":
                    // Unknown error occurred, inspect error.serverResponse
                    alert(
                      "Une erreur est survenue lors de l'envoie de votre fichier, réessayer plus tard."
                    );
                    break;
                  default :
                    break;
                }
              },
              () => {
                console.log("Image uploaded to the bucket!");



                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then(async (downloadURL) => {
                    toast.success('Fichier envoyé, traitement en cours.')
                    cb(downloadURL)
                  });
              }
            ); 


  }; 

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
        console.log('error', formd)
        toast.error('Champs obligatoire manquant.')
        return;
    }  

    if (l){
        return;
    }
    console.log('formd', formd)

    setValidated(true);
    setL(true);  
    if (formd?.pieces?.length > 0){
        formd?.pieces?.forEach((p, i)=>{
            const lsm = p?.photos_update?.length;
            if (lsm > 0 ){
                var ng = [];
                var index = 0  ;

                Array.from(p?.photos_update).forEach(async (n) => {
                    sendFile(n, async (downloadURL) => { 
                       ng.push(downloadURL)
                       index += 1;
                      console.log( index ,  lsm)
                       if (index === lsm){  
                        await firebase.firestore().collection('etatsdeslieux').doc(id).get().then(async doc => {
                            if (doc){ 
                              let d = doc.data()
                              let ps = d.pieces
                              let s = p; 
                              let nphooto = ng
                              ps[i].photos?.forEach(old => {
                                nphooto.push(old)
                              });

                              s.photos = nphooto;
                              ps[i] = s;
                                await firebase.firestore().collection('etatsdeslieux').doc(id).update({pieces:ps, _update_At : new Date()})
                                .then( () => {
                                    fmi();    
                                 })
                                 
                            }
                        })       
                       }
                   });
                 })
            }
        })
    } 
        var t = {...formd};
        t._update_At = new Date(); 
        let npices = []
        t?.pieces?.forEach(s => {
            let sd = s;
            delete sd.photos_update 
            npices.push(sd)
        });
        delete t._create_At;
        delete t.checkin;
        delete t.checkout;
        firebase.firestore().collection('etatsdeslieux').doc(id).update(t).then(() => {
            toast.success('Modification réalisé avec succès');
            setValidated(false);
            setL(false); 
        }).catch(()=> {
            setValidated(false);
            setL(false); 
            console.log('error', error)
            t.email = al
            var errorMessage = error.message;
            toast.error(errorMessage);
        })
    

    
    
};


  const handleChange = e => { 
    let d = {...formd};
    console.log(e.target.name, e.target?.checked,e.target?.value ); 
    if (e.target.name === "is_owner"){
        d[e.target.name] = e.target.checked;
        setIs_Owner(e.target.checked)
    }else{
        if (e.target.name === "type"){
            d[e.target.name] =  e.target.value === "moral" ? "moral" : "physique";
            setMoral(e.target.value === "moral")
        }else{
            d[e.target.name] = e.target.value;
            if (e.target.name === "email"){
                setEmails(e.target.value)
            }
        }
    } 
    setFrom(d); 
  }; 

  const getAllUser = async () => { 
    await firebase.firestore()
      .collection("users") 
      .get().then((snap)=> {
        let s = [];
        snap.forEach((d) => {
          var l = d.data(); 
          if (l?.delete){
            // supprimer donc ne pas affiché
          }else{ 
              const dr = {value : d.id, label: `${l?.lastName} ${l?.firstName}`}
              s.push(dr) 
          }
          setUsers(s);
        })
    })
      .catch((error) => {
        console.log("error", error); 
      });
  };

 
 

  const getInfo = (property) => {
    let infos = []; 
    property?.forEach((p) => { 
        let ps = `${p?.nameHouse}_info`; 
        infos.push({id : p?.id, info : formd[ps]});
    });
    return infos;
  }


  // const generatePDF = () => { 
  //   // console.log("valueVillaPossible", valueVillaPossible)
  //   // console.log("client",formd)
  //   if (lsendE){
  //       return;
  //   }
  //   let property = []
  //   valueVillaPossible?.forEach((ps) => {
  //       villas?.forEach((p) => {
  //           if (p.data && ps.value === p.value){
  //               let d = p.data;
  //               d.id = p.value
  //               property.push(d);
  //           }
  //       })
  //   })
    
  //   if (formd?.client && property.length > 0){
  //       // console.log("client", formd?.client, property);

  //       if (formd?.emails){
  //           let em =formd?.emails;
  //           // formd?.emails.split(',').forEach(e=>{
  //           //     let d = e.trim();
  //           //     if (d.length > 0 && validateEmail(d)){
  //           //         em.push(d);
  //           //     }
  //           // }) 
  //           if (em.length > 0 ){
  //              const  infos = getInfo(property) ;
  //               // envoie du mail
  //               setLsendE(true)

  //               fetch(`${API_URL}sendEmailDemandList`, {
  //                   method: "POST",
  //                   headers: { "Content-Type": "application/json" },
  //                   body: JSON.stringify({ list : property ,client : em, infos : infos }),
  //               }).then((res) => res.json())
  //                   .then(async (data) => {
  //                   //   console.log("data", data);
  //                     setLsendE(false) 
  //                       if (data.success){  
  //                           let sd = {
  //                               statut : "Envoie email liste des biens au client",
  //                               date: new Date(),
  //                               data: JSON.stringify({emails : em, property: valueVillaPossible}),
  //                               uid : firebase.auth().currentUser.uid
  //                           }  
  //                           toast.success("Envoie de l'email réussi")
  //                           await firebase.firestore().collection(`demands/${id}/logs`).add(sd)
  //                           getLogs()
  //                       }   
  //                   }); 
  //           }
  //       }
  //   }


  //   // let sd = {
  //   //     statut : "Génération interne",
  //   //     date: new Date(),
  //   //     data: JSON.stringify({info : "Rapport de la demande"}),
  //   //     uid : firebase.auth().currentUser.uid
  //   // }  
  //   // firebase.firestore().collection(`demands/${id}/logs`).add(sd)
  //   // getLogs()
  // }


  const delItPI = async (index,   fulldata, lari) => {
    let nphoto = []
    fulldata?.forEach((p, i) => {
        if (i !== index){
            nphoto.push(p?.toString() || p )
        }
    })
    let npieces = pieces;
    npieces[lari].photos = nphoto;
     
    console.log("npieces", npieces)
    setL(true);
    try {
      firebase.firestore().collection('etatsdeslieux').doc(id).update({pieces:npieces}).then((snap)=> {
        setPieces(npieces)
        toast.success("Le fichier à été supprimé");
        setL(false);
      })
    } catch (err) {
      setL(false);
      // eslint-disable-next-line no-console
      console.log(err);
      toast.error("Une erreur s'est produite");
    } 
  }

  const delpi = (index,  fulldata, lari) => {
    if(confirm(`Êtes vous certain de vouloir supprimer la photo/vidéo ?`)){
      delItPI(index, fulldata, lari);
    }
  }

  const newEtatlieu = () => {
    toast.warn('Création en cours, chargement ... ')
    let pre = {...formd}
    pre._create_At = new Date();
    pre._update_At = new Date();
    pre.statut = { value: 'created', label: 'En cours' }
    pre.type = {value:'out',label: 'Sortie'};
    pre.inId = id;

    firebase.firestore().collection('etatsdeslieux').add(pre).then((doc)=>{
        toast.success('créer, redirection en cours') 
        window.location.href = '/etatsdeslieux/edit/'+doc.id
    }).catch(()=> {
        toast.error('Réessayer, un problème est survenu')
    })

  }

  return (<>
  <FalconComponentCard>
        <FalconComponentCard.Header title={`Etat des lieux (${formd?.type?.label || 'chargement...'}) - ${id}`} light={false} noPreview={true}  />
        <FalconComponentCard.Body >
            {formd?.client ? (
                <Form noValidate validated={validated} onSubmit={handleSubmit}>

                <Row className="mb-3">
                   <Form.Group as={Col} md="5" controlId="bookingorder">
                   <Form.Label>Client</Form.Label>
                   <Select
                   required 
                           options={clients}
                           placeholder={clients.length === 0 ? 'Chargement...': 'Choisir le client...' }
                           classNamePrefix="react-select"
                           value={valueClientId}
                           isDisabled={true}
                           onChange={value => 
                               {
                                   let d = formd;
                                   d['client'] = value;
                                   setFrom(d);
                                   if (valueClientId?.value !== value.value){
                                       // si changement de client on efface email et on réinit
                                       let f = formd
                                       f['email'] = undefined;
                                       setFrom(f);
                                       setEmails('')
                                   }
                                   setValueClientId(value)
                                   if (formd['email'] === undefined){
                                       let id = value.value
                                       clients.forEach(d => {
                                           if (d.value === id){
                                               let f = formd
                                               f['email'] = d.email
                                               setFrom(f);
                                               setEmails(d.email)
                                           }
                                       })
                                   } 
                                   
                               }
                           }
                           />
                           {formd &&  <p><a href={`/crm/edit/${formd?.client?.value}`} target='_blank'>Voir le client</a></p>}
                   </Form.Group>
                   <Form.Group as={Col} md="5" controlId="villa">
                   <Form.Label>Propriété</Form.Label>
                   <Select   
                           options={villas} 
                           placeholder='Choisir la villa...' 
                           classNamePrefix="react-select"
                           value={valueVilla}
                           onChange={value => {
                               setValueVilla(value)
                               let d = formd;
                               d['property'] = value;
                               setFrom(d);
                           
                           }}
                           isDisabled={true}
                        />
                        {formd?.statut && formd?.statut?.value === 'confirmed'  &&  <p><a href={`/etatsdeslieux/pdf/${id}`} target='_blank'>Générer l'état des lieux ({formd?.type?.label || 'chargement..'})</a></p>}
                   </Form.Group>
                                </Row>
   
                <Row  className="mb-3"> 
                    <Form.Group as={Col} md="5" controlId="interlocuteur">
                    <Form.Label>Interlocuteur</Form.Label>
                    <Select options={interlocuteurs}
                            placeholder='Choisir interlocuteur...' 
                            classNamePrefix="react-select"
                            value={valueInterlocuteur}
                            onChange={value => {
                                setValueInterlocuteur(value)
                                let d = formd;
                                d['interlocuteur'] = value;
                                setFrom(d); 
                            }}
                            />
                    </Form.Group>
                </Row>
               <Row className="mb-3">
                   <Form.Group as={Col} md="5" controlId="bookingorder">
                   <Form.Label>Status de l'état des lieux</Form.Label>
                   <Select 
                           required
                           options={[
                               { value: 'canceled', label: 'Annuler' },  
                               { value: 'created', label: 'En cours' },  
                               { value: 'confirmed', label: 'Confirmer' }, 
                           ]}
                           placeholder='Choisir le status...' 
                           classNamePrefix="react-select"
                           value={valueStatut}
                           onChange={value => {
                               setValueStatut(value)
                           
                               let d = formd;
                               d['statut'] = value;
                               setFrom(d);
                           
                           }}
                           isDisabled={formd?.canEdit === false}
                           />
                {valueStatut?.value === 'confirmed' && formd?.type?.value === 'in' &&  (<Form.Label><a href='#' onClick={newEtatlieu}>Créer un état des lieux de sortie</a></Form.Label>)}
           
                   </Form.Group> 
   
                   <Form.Group as={Col} md="4" controlId="booking_id">
                   <Form.Label>Numéro de réservation (identifiant interne)</Form.Label>
                   <Form.Control  
                       type="text"
                       value={formd.booking_id}
                       name="booking_id"
                       onChange={handleChange}
                       placeholder="Identifiant interne" 
                       disabled={true}
                   /> 
                   </Form.Group>
                    
   
                   <hr className="mt-3" />  
                    
   
                   <Row className="mb-3">
                   
                   <Form.Group as={Col} md="3" controlId={`ScheduleStartDate`}>
                       <Form.Label>Check-in</Form.Label>
   
                       <DatePicker
                       
                       disabled={true}
                       showTimeSelect
                       dateFormat="dd/MM/yyyy HH:ss"
                       selected={checkIn} 
                       startDate={checkIn}
                       endDate={checkOut} 
                       timeFormat="p"   
                       selectsStart
                       onChange={newDate => {  
                           let d = formd;
                           d['checkin'] = newDate;
                           setFrom(d)
                           setCheckIn(newDate) 
                       }}
                       customInput={
                           <CustomDateInput
                           disabled
                           formControlProps={{
                               placeholder: 'jj/mm/yy',
                               disabled : true
                           //     ...register(`ScheduleStartDate${index}`)
                           }}
                           />
                       }
                       />
                   </Form.Group>
   
   
                   <Form.Group as={Col} md="3" controlId={`ScheduleEndDate`}>
                       <Form.Label>Check-out</Form.Label>
   
                       <DatePicker 
                       isDisabled={true}
                       disabled={true}
                       selected={checkOut}
                       showTimeSelect 
                       minDate={checkIn}
                       selectsEnd 
                       startDate={checkIn}
                       endDate={checkOut}
                       dateFormat="dd/MM/yyyy HH:ss"
                       onChange={newDate => {
                           let d = formd;
                           d['checkout'] = newDate;
                           setFrom(d)
                           setCheckOut(newDate) 
                       }}
                       customInput={
                           <CustomDateInput
                           disabled
                           formControlProps={{
                               placeholder: 'jj/mm/yy',
                               disabled : true
                           //     ...register(`ScheduleStartDate${index}`)
                           }}
                           />
                       }
                       />
                   </Form.Group> 
                    
                   </Row>

                   <hr style={{marginTop:10}}/> 
                   <Row className="mb-3">   
                   <Form.Label>Pièces</Form.Label> 
                   {
                    pieces.map((piece, index) => {
                        return (<Row className="mb-3">

                        <Form.Group as={Col} md="3" className="mb-3">  
                            <Form.Label>Titre</Form.Label>
                            <Form.Control 
                            name={`pieceTitle_${index}`}
                            placeholder="Titre"
                            value={piece.title}
                            onChange={(e) => {
                                let o = [...pieces];
                                let m = {...piece};
                                m.title = e.target.value
                                o[index] = m; 
                                setPieces(o);
                                let d = {...formd}; 
                                d['pieces'] = o;  
                                setFrom(d); 
                            }} 
                            /> 
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="stategen">
                        <Form.Label>État général</Form.Label>
                        <Select 
                            required
                            options={
                                    [
                                      {value :'neuf' , label: 'Neuf'},
                                        {value :'goodmoins' , label: 'Correct'}, 
                                        {value :'usage' , label: 'État d\'usage'},
                                          {value :'malus' , label: 'Détérioré'},
                                    ]
                                }
                                placeholder='Choisir...' 
                                classNamePrefix="react-select"
                                value={piece?.state}
                                onChange={(value) => {
                                    let o = [...pieces];
                                    let m = {...piece};
                                    m.state = value
                                    o[index] = m; 
                                    setPieces(o);
                                    let d = {...formd}; 
                                    d['pieces'] = o;  
                                    setFrom(d); 
                            }}
                        />
                        </Form.Group>

                        <Form.Group as={Col} md="2" className="mb-3">  
                            <Form.Label>Niveau</Form.Label>
                            <Form.Control 
                            name={`pieceLevel_${index}`}
                            placeholder="Niveau"
                            value={piece.level}
                            onChange={(e) => {
                                let o = [...pieces];
                                let m = {...piece};
                                m.level = e.target.value
                                o[index] = m; 
                                setPieces(o);
                                let d = {...formd}; 
                                d['pieces'] = o;  
                                setFrom(d); 
                            }} 
                            /> 
                        </Form.Group>


                        <IconButton as={Col} md="1" onClick={() => { 
                            let arr = pieces;  
                            arr.splice(index, 1);   
                            setPieces(arr);
                            let d = {...formd}; 
                            d['pieces'] = arr;  
                            setFrom(d);  
                            }}
                            variant="falcon-danger"
                            size="sm"
                            icon="trash"
                            transform="shrink-3"
                            className='me-2'
                            style={{width: 60, height: 25, marginTop: 35}} 
                            > 
                            </IconButton> 

                        <Row className="mb-3">
                <Form.Group controlId="formFileMultiple" className="mb-3" as={Col} md="5" >
                    <Form.Label>Photos / vidéos</Form.Label>
                    <Form.Control type="file" multiple name={`piecephotos_${index}`} accept="image/png, image/gif, image/jpeg, video/mp4,video/mkv, video/x-m4v,video/*"
                     onChange={(value) => {
                        let f = value?.target?.files;

                        let o = [...pieces];
                        let m = {...piece};
                        m.photos_update = f
                        o[index] = m; 
                        setPieces(o);
                        let d = {...formd}; 
                        d['pieces'] = o;  
                        setFrom(d); 
                    }} 
                     />
                </Form.Group>

                {
                  piece?.photos && (
                    <Form.Group controlId="formFileMultiple" className="mb-3" as={Col} md="5" >
                    {
                      piece?.photos?.map((f,i)=>{
                        return <p>
                            <a target='_blank' href={f}>
                              <Avatar src={f} className="me-2" size="2xl" rounded />
                            </a>
                         <IconButton onClick={() => {delpi(i,piece?.photos , index );}} variant="falcon-danger" size="sm" icon="trash" transform="shrink-3" className='me-2' >
                          <span className="d-none d-sm-inline-block ms-1"></span>
                        </IconButton> 
                        </p>
                       })
                    }
                    </Form.Group>
                  )
                }
            </Row>
 
            <Form.Label>Constats</Form.Label> 
                <Form.Group className="mb-3">

                <Form.Control as="textarea" name="constat"
                value={piece.constat}
                onChange={(e) => {
                    let f = e.target.value ;

                    let o = [...pieces];
                    let m = {...piece};
                    m.constat = f
                    o[index] = m; 
                    setPieces(o);
                    let d = {...formd}; 
                    d['pieces'] = o;  
                    setFrom(d); 
                }} 
                placeholder="Laisser un constat ici"
                style={{ height: '100px' }}
            /> 
            </Form.Group>
         
                        
                        </Row>
                        )
                    })
                    }

                    </Row>
                    <Row className="mb-3">   
                    <div>
                    <Flex
                        alignItems="center"
                        className="mb-4 text-primary cursor-pointer fs-0"
                        onClick={() => {
                        let o = [...pieces];
                        if (o[o.length - 1]?.title?.trim() !== ""  ){ 
                        o.push({title: "", state: null, level : '', photos: [], constat : '' });
                        setPieces(o);
                        }
                        }}
                        >
                        <span className="circle-dashed">
                        <FontAwesomeIcon icon="plus" />
                        </span>
                        <span className="ms-3">Ajouter une nouvelle pièce</span>
                    </Flex> 
                    </div>

                   </Row>
   
                <hr style={{marginTop:10}}/> 
               <Form.Label>Commentaire</Form.Label> 
               <Form.Group className="mb-3">
   
               <Form.Control as="textarea" name="comment"
                   placeholder="Laisser un commentaire ici"
                   style={{ height: '100px' }}
                   value={formd.comment}

                   disabled={formd?.canEdit === false}
                   onChange={handleChange}
                   /> 
               </Form.Group>
   
   
   
   
               </Row>
                  
               

                <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Modifier'}</Button>
               <br/><br/>
                { formd?.with && formd?.booking_id
                    && (
                    
                <IconButton

                variant="falcon-default"
                size="sm"
                icon="file"
                transform="shrink-3"
                className='me-2'
                  onClick={() => navigate('/booking/edit/'+formd?.booking_id)}
  
              >
                Voir la réservation lié
                  </IconButton>
                    
                    )}

               </Form>



            ) : <p>Chargement ...</p>}
        </FalconComponentCard.Body>
       

    </FalconComponentCard>

 
</>
    
  );  
  };

export default EditEtatdeslieux;
